import { useEffect, useState } from 'react';
import type { IEmployment } from '../../interfaces/employment';
import { sleep } from '../../../../common/utils/sleep';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';
import { Loader } from '../../elements/common';
import { SelectEmployment } from './SelectEmployment';

let selectEmploymentWaiting = false;

export function LoginSelectEmployment() {
    const abortableFetch = useAbortableFetch();
    const [employments, setEmployments] = useState<IEmployment[]>();

    useEffect(() => {
        loadEmployments();
    }, []);

    return employments === undefined ? (
        <Loader
            centered
            large
        />
    ) : (
        <SelectEmployment
            employments={employments}
            selectEmployment={selectEmployment}
        />
    );

    async function loadEmployments() {
        const result = await abortableFetch.fetchJson('/api/user/employments', 'GET');
        setEmployments(result.json.items);
    }

    async function selectEmployment(employmentId: string) {
        /*
            FIXME:
            Wait for 1 second to fix (in most cases) the IE11 issue that the session is reset and the user is logged out when a long
            running request is returning after the employment is changed.
            Update: This problem is also present in Chrome thus the conditional for IE is removed.
            spike to fix this: CS-10405
            In CS-26018 the `selectEmploymentWaiting` var was added to prevent firing the api call multiple times
            when the user double-clicks. Removing the `sleep` may be more effective but it may reintroduce another bug?
        */
        if (selectEmploymentWaiting) {
            return;
        }
        selectEmploymentWaiting = true;
        await sleep(1000);
        const url = '/api/user/employment/';
        const data = { employmentId };
        await abortableFetch.fetchJson(url, 'POST', data);
        selectEmploymentWaiting = false;
        window.location.href = '/home?loginFlow=true';
    }
}
